import {ChangeDetectionStrategy, Component} from '@angular/core';
import {NotificationDialog, NotificationDialogDefinition} from '@aviary/dialogs/notification-dialog/notification-dialog.types';
import {NotificationDialogComponent} from '@aviary/dialogs/notification-dialog/notification-dialog.component';

@Component({
  selector: 'px-file-claim-success-dialog',
  template: `
    <mx-notification-dialog [definition]="dialogDefinition">
      <div class="flex flex-col gap-y-4 text-title-medium">
        <div>Your claim was successfully submitted. We’ll review your claim and reach out if we have further questions.</div>
        <div>Thank you!</div>
      </div>
    </mx-notification-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NotificationDialogComponent]
})
export class FileClaimSuccessDialog implements NotificationDialog<undefined> {
  dialogData: undefined;

  public readonly dialogDefinition: NotificationDialogDefinition = {
    title: 'Claim Submitted',
    confirmButtonLabel: 'Close'
  };
}
